export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.readAsBinaryString(blob);
    reader.onloadend = () => {
      resolve(btoa(reader.result as string));
    };
  });
};

type Subscription<T> = (value: T) => void;

export type Writable<T> = {
  subscribe: (subscription: Subscription<T>) => () => void;
  set: (newValue: T) => void;
};

export const writable = <T>(initialValue: T): Writable<T> => {
  let value: T = initialValue;
  let subscriptions: Array<Subscription<T>> = [];
  return {
    subscribe: (subscription: Subscription<T>) => {
      subscription(value);
      subscriptions.push(subscription);
      return () => {
        const index = subscriptions.indexOf(subscription);
        subscriptions.splice(index, 1);
      };
    },
    set: (newValue: T) => {
      value = newValue;
      subscriptions.forEach((s) => s(value));
    },
  };
};
